import { Action, ThunkAction, configureStore } from "@reduxjs/toolkit";

import { setupListeners } from "@reduxjs/toolkit/query";

import { api } from "./store/api";

import appReducer from "./store/features/appSlice";

import authReducer from "./store/features/authSlice";
import userReducer from "./store/features/userSlice";
import centerReducer from "./store/features/centerSlice";

import modalReducer from "./store/features/components/modalSlice";



import authApi from "./store/api/authApi";
import userApi from "./store/api/userApi";
import { tableReducer } from "./store/features/components/tableSlice";
import { formReducer } from "./store/features/components/formSlice";
import centerApi from "./store/api/centerApi";

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,

    app: appReducer,

    auth: authReducer,
    user: userReducer,
    center: centerReducer,
    table: tableReducer,

    // components reducers

    modal: modalReducer,
    form: formReducer,

  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat(api.middleware)
 
      .concat(authApi.middleware)
      .concat(userApi.middleware)
      .concat(centerApi.middleware)
      ,
  devTools: process.env.NODE_ENV !== "production",
});

setupListeners(store.dispatch);
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
